import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from 'reactstrap';
import Select from 'react-select';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addSiteSurvey, fetchAddressesRequest, fetchCustomersRequest, getCatalogItems, getSebelUsers, getShifts, getSolutions, getTeams } from 'store/actions';
import { FaEdit, FaFileContract, FaFilter, FaHashtag, FaPhoneAlt, FaUserCircle } from 'react-icons/fa';
import { RiContractLine } from 'react-icons/ri';
import DUMMY_USER_IMG from '../../assets/images/dummyUser.jpg';
import axiosInstance from 'pages/Utility/axiosInstance';
import Breadcrumb from 'components/Common/Breadcrumb2';
import toast from 'react-hot-toast';
import { ClipLoader } from 'react-spinners';
import { formatDate, formatTime } from 'helpers/dateFormat_helper';
import Cookies from 'js-cookie';
import { addMinutesToTime } from 'helpers/common_helper';

// CreateSiteSurvey component
const CreateSiteSurvey = () => {
    const [customerType, setCustomerType] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [addressCards, setAddressCards] = useState([]);
    const [profileData, setProfileData] = useState();
    const [catelogueItems, setCatalogueItems] = useState();
    const [SiteSurveyItems, setSiteSurveyItems] = useState([]);
    const [selectedCatalogItem, setSelectedCatalogItem] = useState(null);
    const [itemQuantity, setItemQuantity] = useState('');
    const [scheduledStartDateTime, setScheduledStartDateTime] = useState('');
    const [agentComments, setAgentComments] = useState('');
    const [selectedShift, setSelectedShift] = useState(null);
    const [availableSlots, setAvailableSlots] = useState(null);
    const [checkSubmit,setCheckSubmit] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [modal, setModal] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [customer, setCustomer] = useState(false);
    const [customers, setCustomers] = useState();
    const [selectedTime, setSelectedTime] = useState();
    const [searchFields, setSearchFields] = useState({ contractNumber: "", contactNumber: "", name: "" });
    const [highlightedSlot, setHighlightedSlot] = useState(null);
    const error = useSelector(state => state?.SiteSurvey?.error)
    const SiteSurveys = useSelector(state => state?.SiteSurvey?.SiteSurveys)
    const sebelUsers = useSelector((state) => state.SebelUser.users);
    const loading = useSelector(state => state?.SiteSurvey?.loading)
    const solutions = useSelector(state => state?.Solution.solutions);
    const [selectedSolution,setSelectedSolution] = useState();
    const [sebelUserId,setSebelUserId]= useState()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [team,setTeam]= useState();
    const [tempTime,setTempTime] = useState();
    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));
    if (!permissions2?.map(item => item?.permissionName)?.includes("Add SiteSurvey")) {
        navigate('/pages-403')
    }
    const [errors, setErrors] = useState({});
    const addresses = useSelector((state) => state.Address.addresses);
    const catalogItems = useSelector((state) => state.Catalog.catalogItems);
    const shifts = useSelector((state) => state?.Shift?.shifts);
    const loading2 = useSelector((state) => state?.Shift?.loading);
    const [uniqueTeams, setUniqueTeams] = useState();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const authUser = JSON.parse(Cookies.get('authUser'));
    const userId = JSON.parse(Cookies.get('authUser'))?.userId
    const id = queryParams.get('id');

    useEffect(() => {
        if (catalogItems?.Data?.length > 0) {
            const groupedByCategory = catalogItems?.Data?.reduce((acc, item) => {
                const { categoryName, itemName, catalogueId, surveyTime, image } = item;

                // Check if the category already exists in the accumulator
                if (!acc[categoryName]) {
                    acc[categoryName] = [];
                }

                // Push the item into the respective category
                acc[categoryName].push({
                    value: catalogueId,
                    label: itemName,  // label as the catalogueId (string)
                    surveyTime: surveyTime,
                    image: image
                });

                return acc;
            }, {});

            // Step 2: Create the desired options array
            const optionsArray = Object.keys(groupedByCategory).map((categoryName) => {
                return {
                    label: categoryName,  // Use category name as label
                    options: groupedByCategory[categoryName],  // Use the grouped items as options
                };
            });
            setCatalogueItems(optionsArray);
        }
    }, [catalogItems]);

    const fetchCustomers = async () => {
        try {
            const response = await axiosInstance?.get('', { params: { sp: "usp_SearchCustomer", customerNameEng: searchFields?.name, contactNumber: searchFields?.contactNumber, contractNumber: searchFields?.contractNumber } });
            if (response) {
                setCustomers(response?.data)
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (loading2) return;
        dispatch(getShifts())
        dispatch(getCatalogItems());
        dispatch(getSolutions())
        dispatch(getSebelUsers())
    }, [dispatch]);

    useEffect(() => {
        fetchCustomers();
    }, [searchFields])

    useEffect(() => {
        if (addresses?.Data?.length > 0) {
            setAddressCards(addresses?.Data);
        }
    }, [addresses]);

    useEffect(() => {
        if (id && customers?.Data?.length > 0) {
            setCustomerType("existing");
            const selectedCustomer = customers.Data.find(customer => customer.customerId == id);
            if (selectedCustomer) {
                setSelectedCustomer({
                    value: selectedCustomer.customerId,
                    label: selectedCustomer.customerNameEng,

                });
            }
        }
    }, [id, customers?.Data]);

    const handleCustomerTypeChange = (e) => {
        setCustomerType(e.target.value);
        setSelectedCustomer(null);
        setAddressCards([]);
        setSelectedAddress(null);
        setProfileData(null);
        if (e.target.value === 'new') {
            navigate(`/createCustomer`, { state: { from: window.location.pathname } })
        } else {
            setModalOpen(true)
        }
    };

    const fetchCustomer = async (id) => {
        const response = await axiosInstance.get('', { params: { sp: 'usp_GetCustomerById', customerId: id } });
        setProfileData(response?.data?.Data?.[0]);
    };

    const showSuccess = (msg) => {
        toast.dismiss();
        toast.success(msg)
    }

    const showError = (msg) => {
        toast.dismiss();
        toast.error(msg)
    }

    useEffect(() => {
        if (selectedCustomer) {
            dispatch(fetchAddressesRequest(selectedCustomer?.value));
            fetchCustomer(selectedCustomer?.value);
        } else {
            setAddressCards([]);
            setProfileData(null);
        }
    }, [selectedCustomer, dispatch]);


    const handleAddressSelect = (address) => {
        setSelectedAddress(address.customerAddressId === selectedAddress?.customerAddressId ? null : address);
    };

    const handleAddSiteSurveyItem = () => {
        if (selectedCatalogItem && itemQuantity) {
            if (SiteSurveyItems?.filter(item => item?.id == selectedCatalogItem?.value)?.length === 1) {
                showError("Catalogue item already exists")
            } else {
                const newItem = { id: selectedCatalogItem?.value, catalogItem: selectedCatalogItem, estimatedTime: selectedCatalogItem?.surveyTime * itemQuantity, quantity: itemQuantity, perTime: selectedCatalogItem?.surveyTime, image: selectedCatalogItem?.image };
                setSiteSurveyItems([...SiteSurveyItems, newItem]);
                setSelectedCatalogItem(null);
                setItemQuantity('');
                setSelectedSlot(null);
                setSelectedTime(null);
                setHighlightedSlot(null)
            }
        } else if (!selectedCatalogItem) {
            showError("Please select a catalog item!")
        } else if (!itemQuantity) {
            showError("Please enter the quantity")
        }
    };

    const handleDeleteSiteSurveyItem = (id) => {
        setSiteSurveyItems(SiteSurveyItems.filter((item) => item.id !== id));
        setSelectedSlot(null);
        setSelectedTime(null);
        setHighlightedSlot(null)
    };

    // Validation function
    const validateForm = () => {
        const newErrors = {};
        const currentDateTime = new Date();
        if(!selectedSolution) newErrors.solution = "Please select a solution"
        if(!sebelUserId)newErrors.sebelUserId = "Sebel userId is required"
        if (!customerType) newErrors.customerType = "Please select a customer type.";
        if (customerType === 'existing' && !selectedCustomer) showError("Please select a customer");
        if (!selectedAddress) newErrors.selectedAddress = "Please select an address.";
        if (!scheduledStartDateTime) {
            newErrors.scheduledStartDateTime = "Please select a start date";
        } else if (new Date(scheduledStartDateTime).setHours(0, 0, 0, 0) < currentDateTime.setHours(0, 0, 0, 0)) {
            newErrors.scheduledStartDateTime = "You cannot select a past date as start date";
        }
        if (!agentComments) newErrors.agentComments = "Please provide agent comments.";
        if (!selectedShift) newErrors.selectedShift = 'Please select a shift.';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
     
    useEffect(()=>{
        if(checkSubmit){
            validateForm();
        }
    },[selectedSolution,sebelUserId,selectedCustomer,selectedAddress,scheduledStartDateTime,selectedShift,agentComments])

    const formattedSiteSurveyItems = {
        items: SiteSurveyItems.map(item => ({
            catalogueId: item.catalogItem.value,
            quantity: parseInt(item.quantity)
        }))
    };

    /// submit form
    const handleSubmit = async () => {
        setCheckSubmit(true);
        if (validateForm()) {
            // Submit the form
            if (selectedTime) {
                dispatch(addSiteSurvey({
                    "sp": "usp_InsertSiteSurvey",
                    "customerID": selectedCustomer?.value,
                    "surveyTimeInMins": 60,
                    "createdBy": userId,
                    "customerAddressId": selectedAddress?.customerAddressId,
                    "teamId": highlightedSlot?.teamId,
                    "scheduledStartDateTime": formatDate(`${scheduledStartDateTime}T${selectedTime}:00`),
                    "scheduledEndDateTime": formatDate(new Date(`${scheduledStartDateTime}T${selectedTime}:00`).getTime() + (60 * 60000)),
                    "agentComments": agentComments,
                    "solutionId":selectedSolution,
                    "sabelUserId":sebelUserId
                }, navigate))
            } else {
                showError("Please select a slot")
            }

        }
    };

    // clear form after submission
    useEffect(() => {
        setCustomerType('');
        setCustomer(null);
        setCustomers([]);
        setSelectedCustomer(null);
        setSelectedAddress(null);
        setAddressCards([]);
        setProfileData(null);
        setCatalogueItems([]);
        setSiteSurveyItems([]);
        setSelectedCatalogItem(null);
        setItemQuantity('');
        setScheduledStartDateTime('');
        setSelectedShift('')
        setAgentComments('');
        setErrors({});
        setHighlightedSlot("")
        setAvailableSlots([])
        setSebelUserId("")
        setSelectedSolution("")
    }, [SiteSurveys])

    // fetching available slots
    const fetchAvailableSlots = async () => {
        try {
            const response = await axiosInstance.get('', { params: { sp: "usp_GetShiftTeamAvailability", shiftId: selectedShift?.value ? selectedShift?.value : null, scheduledDate: scheduledStartDateTime ? scheduledStartDateTime : null,solutionId:selectedSolution,customerId: selectedCustomer?.value } });
            if (response) {
                setAvailableSlots(response?.data?.Data);
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        if (scheduledStartDateTime && selectedShift && selectedSolution) {
            fetchAvailableSlots();
        }
    }, [scheduledStartDateTime, selectedShift,selectedSolution])

    const toggleModal = () => setModal(!modal);

    const handleSlotClick = (team, slot) => {
        setTeam(team);
        setSelectedSlot({ team, slot });
        // setSelectedTime("");
        setTempTime("")
        toggleModal();
    };

    const handleTimeChange = (e) => {
        setTempTime(e.target.value)
        // setSelectedTime(e.target.value);
    };
     useEffect(() => {
        setSelectedTime(undefined);
        setHighlightedSlot(null);
    }, [scheduledStartDateTime]);
       

    const handleContinue = () => {
        if (!selectedSlot) return;

        if (
            (!tempTime && !selectedTime) ||
            (!tempTime && selectedTime && (
                selectedSlot?.slot.FromTime !== highlightedSlot?.fromTime ||
                selectedSlot?.slot.ToTime !== highlightedSlot?.toTime ||
                selectedSlot?.team.teamId !== highlightedSlot?.teamId
              ))
          ) {
            showError("Please select the time");
            return;
        }
        // Construct date from selectedSlot's date and tempTime
        const selectedDate = new Date(selectedSlot.slot.FromTime);
        const [selectedHour, selectedMinute] = tempTime.split(":");
        selectedDate.setHours(parseInt(selectedHour, 10));
        selectedDate.setMinutes(parseInt(selectedMinute, 10));
        selectedDate.setSeconds(0);
        selectedDate.setMilliseconds(0);
    
        const selectedStartDateTime = new Date(selectedDate);
        const currentDateTime = new Date();

        const isSameDay = selectedStartDateTime.toDateString() === currentDateTime.toDateString();
        if (isSameDay && selectedStartDateTime <= currentDateTime) {
            showError("Please select a future time");
            return;
        }
        
        const totalEstimatedTimeInMs = (
            SiteSurveyItems?.length
                ? SiteSurveyItems.reduce((sum, item) => sum + (item?.estimatedTime || 0), 0)
                : 60 // default 60 minutes
        ) * 60000; 

        const calculatedEndDateTime = new Date(
            selectedStartDateTime.getTime() + totalEstimatedTimeInMs
        );

        const slotEndTime = new Date(selectedSlot.slot.ToTime);

        // Validation: Check if calculated end time exceeds slot's end time
        if (calculatedEndDateTime > slotEndTime) {
            showError("The selected time and estimated work exceed the slot's end time!");
            return;
        }
        const fromTime = new Date(selectedSlot.slot.FromTime).getTime();
        const toTime = new Date(selectedSlot.slot.ToTime).getTime();

        const selectedTimeInMs = selectedDate.getTime();

        // Validation
        if (selectedTimeInMs < fromTime || selectedTimeInMs > toTime) {
            showError("Selected time is not within the range of this slot!")
            return;
        }

        if (tempTime){
            setSelectedTime(tempTime);
        }

        // Highlight the selected slot
        setHighlightedSlot({
            teamId: selectedSlot.team.teamId,
            fromTime: selectedSlot.slot.FromTime,
            toTime: selectedSlot.slot.ToTime,
            selectedTime:tempTime,
        });

        toggleModal();

    };

    useEffect(() => {
        if (availableSlots) {
            setUniqueTeams(availableSlots?.reduce((acc, team) => {
                if (!acc.some(t => t.teamId === team.teamId)) {
                    acc.push(team);
                }
                return acc;
            }, []))
        }
    }, [availableSlots])

    const toggleCustomerModal = () => {
        setModalOpen(!modalOpen);
        setCustomerType("");
    }

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchFields((prev) => ({ ...prev, [name]: value }));
    };

    // Filter customers based on search fields
    const handleSearch = () => {
        const { contractNumber, contactNumber, name } = searchFields;
        let filtered = customers?.Data?.filter((customer) => {
            return (
                (!contractNumber || customer.contractNumber?.includes(contractNumber)) &&
                (!contactNumber || customer.contactNumber?.includes(contactNumber)) &&
                (!name || customer.customerNameEng?.toLowerCase().includes(name.toLowerCase()))
            );
        });
    };

    // Handle customer selection inside modal
    const handleCustomerSelect = (selected) => {
        setCustomer(selected);
    };

    const handleCustomerSelectSubmit = () => {
        setSelectedCustomer(customer);
        setModalOpen(false);
    }

    const customOption = (props) => {
        const { data, innerRef, innerProps } = props;

        return (
            <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }} className='p-2'>
                <img src={`${process.env.REACT_APP_BASE_URL}${data.image}`} alt={data.label} style={{ width: 20, height: 20, marginRight: 10, borderRadius: "10px" }} />
                <span>{data.label}</span>
            </div>
        );
    };

    return (
        <div className="page-content">
            <Modal isOpen={modalOpen} toggle={toggleCustomerModal} className='modal-dialog-centered' backdrop="static">
                <ModalHeader toggle={toggleCustomerModal}>Filter Customers</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm={6}>
                            <label>Contract Number</label>
                            <Input type="text" name="contractNumber" placeholder='Enter Contract Number' value={searchFields.contractNumber} onChange={handleInputChange} />
                        </Col>
                        <Col sm={6}>
                            <label>Contact Number</label>
                            <Input type="text" name="contactNumber" placeholder='Enter Contact Number' value={searchFields.contactNumber} onChange={handleInputChange} />
                        </Col>
                        <Col sm={6}>
                            <label>Name</label>
                            <Input type="text" name="name" placeholder='Enter Name' value={searchFields.name} onChange={handleInputChange} />
                        </Col>
                        <Col sm={6}><Button color="primary" style={{ marginTop: "28px" }} onClick={handleSearch}>
                            Search
                        </Button></Col>
                    </Row>

                    <label className="mt-4">Select Customer</label>
                    <Select
                        options={customers?.Data?.map((customer) => ({
                            value: customer.customerId,
                            label: customer.customerNameEng,
                        }))}
                        onChange={handleCustomerSelect}
                        placeholder="Select a Customer"
                        isClearable={true}
                        value={customer}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleCustomerModal}>
                        Close
                    </Button>
                    <Button color="primary" onClick={handleCustomerSelectSubmit} disabled={!customer}>
                        Continue
                    </Button>
                </ModalFooter>
            </Modal>
            <div className="d-flex justify-content-between align-items-center ms-3">
                <Breadcrumb
                    title="Create Site Survey"
                    breadcrumbItems={[{ title: 'Dashboard', link: '/dashboard' }, { title: 'Create Site Survey', link: '#' }]}
                />
                <Button className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center" onClick={() => navigate('/SiteSurveys')}>
                    Back
                </Button>
            </div>

            <div className="bg-white p-4" style={{ borderRadius: '8px' }}>
                {/* Customer Type Section */}
                <FormGroup tag="fieldset">
                    <h5>Customer Type</h5>
                    <div className='d-flex gap-3 align-items-center'>
                        <div>
                            <Label check>
                                <Input
                                    type="radio"
                                    value="new"
                                    checked={customerType === 'new'}
                                    onChange={handleCustomerTypeChange}
                                    style={{ border: "1px solid gray" }}
                                />
                                &nbsp; New Customer
                            </Label>
                        </div>
                        <div>
                            <Label check>
                                <Input
                                    type="radio"
                                    value="existing"
                                    checked={customerType === 'existing'}
                                    onChange={handleCustomerTypeChange}
                                    style={{ border: "1px solid gray" }}
                                />
                                &nbsp; Existing Customer
                            </Label>
                        </div>
                    </div>
                    {errors.customerType && <div className="text-danger">{errors.customerType}</div>}
                </FormGroup>

                <div className='d-flex  mb-3'>
                    <div>
                        <label>Solution</label>
                        <Select
                            id="solution"
                            options={solutions?.map(item=>({label:item?.solutionName,value:item?.solutionId}))}
                            value={solutions?.map(item=>({label:item?.solutionName,value:item?.solutionId}))?.find(option => option?.value == selectedSolution)||""}
                            onChange={option => { setSelectedSolution(option?.value);}}
                            placeholder="Select Solution"
                            isClearable={true}
                            styles={{
                                container: (base) => ({
                                  ...base,
                                  minWidth: '200px',
                                }),
                              }}
                        />
                        {errors.solution && <div className="text-danger">{errors.solution}</div>}
                    </div>
                    <div className='ms-3'>
                        <label for="sebelUserId" className=''>Siebel User ID</label>
                        <Select
                            id="sebelUserId"
                            options={sebelUsers?.Data?.map(item=>({label:item?.sabelUserId,value:item?.id}))}
                            value={sebelUsers?.Data?.map(item=>({label:item?.sabelUserId,value:item?.id}))?.find(option=>option?.value == sebelUserId || "")}
                            onChange={option=>{setSebelUserId(option?.value ||"")}}
                            placeholder="Select Siebel User ID"
                            isClearable={true}
                            styles={{
                                container: (base) => ({
                                  ...base,
                                  minWidth: '200px',
                                }),
                              }}
                        />
                        {errors.sebelUserId && <div className="text-danger">{errors.sebelUserId}</div>}
                    </div>
                </div>

                {/* Customer Selection Section */}
                {(customerType === 'existing' && selectedCustomer  && selectedSolution && sebelUserId) && (
                    <Row className="customer-selector">
                        <Col md={6}>
                            <label>Customer </label> <span className='text-danger'>*</span>
                        </Col>
                    </Row>
                )}

                {(selectedCustomer && customerType === 'existing'  && selectedSolution && sebelUserId) && (
                    <Row className="mb-3 mt-4 py-2 mx-1" style={{ border: '1px solid lightgray', borderRadius: '8px' }}>
                        <Col md={4} className="text-center d-flex justify-content-center align-items-center">
                            {/* Dummy Profile Picture */}
                            <img
                                src={DUMMY_USER_IMG}
                                alt="Profile"
                                className="rounded-circle"
                                style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                            />
                        </Col>
                        <Col md={8}>
                            <Row className="d-flex align-items-center">
                                <Col xs={6}>
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="p-2" style={{ backgroundColor: 'lightgray', borderRadius: '50%' }}>
                                            <FaUserCircle size={25} />
                                        </div>
                                        <div className="d-flex justify-content-center align-items-center">
                                            <div className="mt-3">
                                                <h6 className="text-black" style={{ fontWeight: 'bold' }}>Customer Name: </h6>
                                                <p className="ms-1">{profileData?.customerNameEng}</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={6}>
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="p-2" style={{ backgroundColor: 'lightgray', borderRadius: '50%' }}>
                                            <RiContractLine size={23} />
                                        </div>
                                        <div className="d-flex justify-content-center align-items-center">
                                            <div className="mt-3">
                                                <h6 className="text-black" style={{ fontWeight: 'bold' }}>Contract Number: </h6>
                                                <p className="ms-1">{profileData?.contractNumber}</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={6}>
                                    <div className='d-flex align-items-center gap-2' >
                                        <div className='p-2' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                                            <FaFileContract size={23} />
                                        </div>
                                        <div className='d-flex  justify-content-center align-items-center' >
                                            <div className='mt-3'>
                                                <h6 className='text-black' style={{ fontWeight: "bold" }}>Contract Id:  </h6>
                                                <p className='ms-1'>{profileData?.contractId}</p>
                                            </div>
                                        </div>

                                    </div>
                                </Col>


                                <Col xs={6}>
                                    <div className='d-flex align-items-center gap-2' >
                                        <div className='p-2' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                                            <FaHashtag size={23} />
                                        </div>
                                        <div className='d-flex  justify-content-center align-items-center' >
                                            <div className='mt-3'>
                                                <h6 className='text-black' style={{ fontWeight: "bold" }}>Suscriber Number:</h6>
                                                <p className='ms-1'>{profileData?.subscriberNumber}</p>
                                            </div>
                                        </div>

                                    </div>
                                </Col>
                                <Col xs={6}>
                                    <div className='d-flex align-items-center gap-2' >
                                        <div className='p-2' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                                            <FaPhoneAlt size={23} />
                                        </div>
                                        <div className='d-flex  justify-content-center align-items-center' >
                                            <div className='mt-3'>
                                                <h6 className='text-black' style={{ fontWeight: "bold" }}>Contact Number 1: </h6>
                                                <p className='ms-1'>{profileData?.contactNumber1}</p>
                                            </div>
                                        </div>

                                    </div>
                                </Col>
                                <Col xs={6}>
                                    <div className='d-flex align-items-center gap-2' >
                                        <div className='p-2' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                                            <FaPhoneAlt size={23} />
                                        </div>
                                        <div className='d-flex  justify-content-center align-items-center' >
                                            <div className='mt-3'>
                                                <h6 className='text-black' style={{ fontWeight: "bold" }}>Contract Number 2:  </h6>
                                                <p className='ms-1'>{profileData?.contactNumber2}</p>
                                            </div>
                                        </div>

                                    </div>
                                </Col>
                            </Row>
                            {/* Edit Button */}
                            <div className="text-end">
                                <Button color="primary" onClick={() => navigate(`/customerProfile/${selectedCustomer?.value}`, { state: { from: window.location.pathname } })}>
                                    View Profile
                                </Button>
                            </div>
                        </Col>
                    </Row>
                )}

                {/* Address Selection Section */}
                {(addressCards?.length > 0 && customerType === 'existing' && selectedCustomer  && selectedSolution && sebelUserId) && (
                    <div className="address-cards mt-4">
                        <h5 className='ms-2'>Select an Address <span className='text-danger'>*</span></h5>
                        <div className="d-flex flex-wrap">
                            {addressCards?.map((address) => (
                                <Card
                                    key={address.customerAddressId}
                                    className={`m-2 ${selectedAddress?.customerAddressId === address.customerAddressId ? 'border-success' : 'border-secondary'}`}
                                    onClick={() => handleAddressSelect(address)}  // Entire Card is clickable
                                    style={{
                                        cursor: 'pointer',
                                        width: '200px',
                                        transition: 'box-shadow 0.3s ease',
                                        boxShadow: selectedAddress?.customerAddressId === address.customerAddressId
                                            ? '0 4px 8px rgba(0, 123, 255, 0.5)'
                                            : '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    <CardBody>
                                        <FormGroup check>
                                            <Label check style={{ cursor: 'pointer' }}> {/* Ensure label is also clickable */}
                                                {/* Remove the Input's readOnly */}
                                                <Input
                                                    type="radio"
                                                    name="address"
                                                    checked={selectedAddress?.customerAddressId === address.customerAddressId}
                                                    onChange={() => { }} // No need for any logic on change
                                                    style={{border: '1px solid gray'}}
                                                />
                                                <h5>Address #{address.customerAddressId}</h5>
                                                <p className="mb-0">{address.addressLine}, {address.area}</p>
                                                <p className="mb-0">{address.areaDescription}</p>
                                                <p>{address.landmark}</p>
                                            </Label>
                                        </FormGroup>
                                    </CardBody>
                                </Card>

                            ))}
                        </div>
                        {errors.selectedAddress && <div className="text-danger">{errors.selectedAddress}</div>}
                    </div>
                )}

                {(selectedCustomer && addressCards?.length <= 0 && customerType === 'existing' && selectedSolution && sebelUserId) && (
                    <div className="d-flex justify-content-center align-items-center mt-3" style={{ minHeight: "100px", border: "1px solid lightgray", borderRadius: "8px" }}>
                        <h6 className='text-center'>No Address Found</h6>
                    </div>
                )}

                {(customerType === 'existing' && selectedCustomer  && selectedSolution && sebelUserId) &&
                    <div>
                        {/* Scheduled Dates and Time Section */}
                        <Row className="mt-3">
                            <Col md={6}>
                                <label htmlFor="scheduledStartDateTime">Scheduled Start Date</label> <span className='text-danger'>*</span>
                                <Input
                                    type="date"
                                    value={scheduledStartDateTime}
                                    onChange={(e) => setScheduledStartDateTime(e.target.value)}
                                    min={new Date().toISOString().split('T')[0]}
                                    placeholder="Scheduled Start Date"
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                                {errors.scheduledStartDateTime && <div className="text-danger">{errors.scheduledStartDateTime}</div>}
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Select Shift</Label> <span className='text-danger'>*</span>
                                    <Select
                                        options={shifts?.Data?.map(item => ({ label: item?.shiftName, value: item?.shiftId }))}
                                        value={selectedShift}
                                        onChange={setSelectedShift}
                                        placeholder="Select a Shift"
                                        isClearable={true}
                                    />
                                    {errors.selectedShift && <div className="text-danger">{errors.selectedShift}</div>}
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row className="pb-3">
                            <h5>Available Slots {(selectedTime) && <span style={{ fontSize: "14px" }}> {`(Current Slot: ${selectedTime}- ${addMinutesToTime(selectedTime,60)})`}</span>}</h5>
                            <Col md={12} style={{ overflowX: "auto" }}>
                                <Table hover>
                                    <thead>
                                        {/* <tr>
                                            <th>Team</th>
                                            <th>Available Slots</th>
                                        </tr> */}
                                    </thead>
                                    <tbody>
                                        {uniqueTeams?.map((team, index) => (
                                            <tr key={team.teamId}>
                                                <td className="" style={{ whiteSpace: "nowrap", verticalAlign: "middle" }}>{authUser?.userRole === "Super Admin" ? team?.teamName : authUser?.userRole === "Supervisor" ? team?.teamName : `Slot-${index + 1}`}</td>
                                                <td>
                                                    <div className="d-flex justify-content-start align-items-center gap-3">
                                                        {availableSlots?.filter((slot) => slot.teamId === team.teamId)
                                                            .reduce((uniqueSlots, slot) => {
                                                                if (
                                                                    !uniqueSlots.some(
                                                                        (s) => s.FromTime === slot.FromTime && s.ToTime === slot.ToTime
                                                                    )
                                                                ) {
                                                                    uniqueSlots.push(slot);
                                                                }
                                                                return uniqueSlots;
                                                            }, [])
                                                            .map((slot, index) => (
                                                                <div
                                                                    key={index}
                                                                    onClick={() =>
                                                                        slot.TimeType !== "Engaged" ? handleSlotClick(team, slot) : ""
                                                                    }
                                                                    style={{
                                                                        backgroundColor:
                                                                            slot.TimeType === "Engaged" ? "lightgray" : "rgb(144, 238, 144)",
                                                                        padding: "7px",
                                                                        margin: "5px 0",
                                                                        cursor: slot.TimeType === "Engaged" ? "not-allowed" : "pointer",
                                                                        opacity: slot.TimeType === "Engaged" ? 0.5 : 1,
                                                                        border: highlightedSlot?.teamId === team.teamId &&
                                                                            highlightedSlot?.fromTime === slot.FromTime &&
                                                                            highlightedSlot?.toTime === slot.ToTime
                                                                            ? "2px solid blue"
                                                                            : "1px solid lightgray",
                                                                        borderRadius: "5px",
                                                                        whiteSpace: "nowrap",
                                                                        color: highlightedSlot?.teamId === team.teamId &&
                                                                            highlightedSlot?.fromTime === slot.FromTime &&
                                                                            highlightedSlot?.toTime === slot.ToTime
                                                                            ? "blue"
                                                                            : slot.TimeType === "Engaged" ? "black" : "white",
                                                                        fontSize: "12px"
                                                                    }}
                                                                >
                                                                    {new Date(slot.FromTime).toLocaleTimeString([], {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })}{" "}
                                                                    -{" "}
                                                                    {new Date(slot.ToTime).toLocaleTimeString([], {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })}
                                                                </div>
                                                            ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        {uniqueTeams?.length <= 0 && <div className='text-center'>No Slots Available</div>}

                                    </tbody>
                                </Table>
                            </Col>
                        </Row>

                        <Modal isOpen={modal} toggle={toggleModal} centered>
                            <ModalHeader toggle={toggleModal}>Select Time</ModalHeader>
                            <ModalBody>
                                <div>
                                    Selected Slot : {new Date(selectedSlot?.slot.FromTime).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}{" "}
                                    -{" "}
                                    {new Date(selectedSlot?.slot.ToTime).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}
                                </div>
                                <div className='d-flex flex-column'>
                                    <label>Select Time:</label>
                                    {console.log(highlightedSlot,selectedSlot,"selections")}
                                    <input
                                        type="time"
                                        value={(highlightedSlot?.teamId === team?.teamId && highlightedSlot?.fromTime === selectedSlot?.slot.FromTime &&
                                            highlightedSlot?.toTime === selectedSlot?.slot.ToTime
                                           )? tempTime || selectedTime:tempTime}
                                        onChange={handleTimeChange}
                                        min={formatTime(selectedSlot?.slot.FromTime)}
                                        max={formatTime(selectedSlot?.slot.ToTime)}
                                    />
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" onClick={handleContinue}>
                                    Continue
                                </Button>
                                <Button color="secondary" onClick={toggleModal}>
                                    Cancel
                                </Button>
                            </ModalFooter>
                        </Modal>

                        {/* Agent Comments Section */}
                        <Row className="mb-3">
                            <Col md={12}>
                                <Label>Comment</Label> <span className='text-danger'>*</span>
                                <Input
                                    type="textarea"
                                    value={agentComments}
                                    onChange={(e) => setAgentComments(e.target.value)}
                                    placeholder="Enter Comment"
                                />
                                {errors.agentComments && <div className="text-danger">{errors.agentComments}</div>}
                            </Col>
                        </Row>
                    </div>}

                {/* Submit Button */}
                <div className="text-end">
                    <Button color="primary" onClick={handleSubmit} style={{ minWidth: "180px" }}>{loading ? <ClipLoader size={17} color="white" /> : "Create Site Survey"}</Button>
                </div>
            </div>
        </div >
    );
};

export default CreateSiteSurvey;
